import { ViewModel,View } from "binder"
import { ElementDecorator } from "src/formBuilder/structure/element";
import { DummyTablePlaceHolderComponentElement } from "../dummyTablePlaceHolderComponent-viewModel";
import  { TdDecoratorView } from "./tdDecorator-view"

export class TdDecoratorViewModel extends ElementDecorator{
    constructor(parentViewModel: DummyTablePlaceHolderComponentElement) {
        super(parentViewModel);
        this.typedParent = parentViewModel;
    }
    GetDefaultView(): View <ViewModel> {
        return new TdDecoratorView();
    }
    public getTypeId(): string {
        return "VM-FAFFEAF7-5B0A-44E5-B89B-0C989A689803"
    }
    private typedParent : DummyTablePlaceHolderComponentElement;
    addNewBefore(){
        this.typedParent.addBefore(this);
    }
    addNewAfter(){
        this.typedParent.addAfter(this);
    }
    delete(){
        this.typedParent.delete(this);
    }
}
